






































import { Component, Prop, Vue } from 'vue-property-decorator';

import sleep from '../../../utils/sleep';


const DEF_LAYOUT = () => [
    ['1','2','3'],
    ['4','5','6'],
    ['7','8','9'],
    ['', '0','clear'],
];


@Component({
    components: {
    },
})
export default class KeypadVue extends Vue {

    // Key layout: a string array with the characters
    @Prop({default:DEF_LAYOUT})
    private layout!: string[][];

    // The code that solves the keypad
    @Prop({default: '123'})
    private code!: string;

    // The font
    @Prop({default: ''})
    private font!: string;

    // Current code introduced
    private current: string = '';

    // Enables the key input
    private enabled = true;

    // Array of leds with their classes
    private leds: any[] = [];

    // When mounted, we create an array with the led css classes
    mounted(){
        this.leds = Array(this.code.length).fill(null).map(x => ({
            active:false,
            success:false,
            error:false,
        }));
    }


    // This is the css style to format the button grid
    get btnsStyle(){

        let style = `grid-template-columns: repeat(${this.layout[0].length}, 55px);`

        if(this.font){
            style += `font-family: '${this.font}';`
        }

        return style;

    }

    // Key event
    press(btn: string){

        // Not enabled, do nothing
        if(!this.enabled) return;

        // Clear
        if(btn === 'clear'){
            this.clear();
            return;
        }

        // Add the new character to the current string
        const char = btn.substring(0, 1);
        const idx = this.current.length;
        this.current += char;

        // Enable other led
        this.leds[idx].active = true;

        //  If there is still room, continue
        if(this.current.length !== this.code.length){
            return;
        }

        // If the code has all the characters, check it
        if(this.code !== this.current){
            this.show_error();
        } else {
            this.show_success();
        }


    }

    // Remove the current code
    clear(){
        this.current = '';
        this.leds.forEach(l => l.active = false);
    }

    // Show an error
    async show_error(){

        this.enabled = false;

        this.leds.forEach(l => l.active = false);

        for(let i=0; i<3; i++){
            this.leds.forEach(l => l.error = true);
            await sleep(200);
            this.leds.forEach(l => l.error = false);
            await sleep(100);
        }

        this.clear();
        this.enabled = true;

    }

    // Show sucess and emit
    async show_success(){

        this.enabled = false;

        this.leds.forEach(l => l.active = false);
        this.leds.forEach(l => l.success = true);

        await sleep(1000);

        this.$emit('success');

    }


}

